import { useState } from "react";
import { CheckIcon, DuplicateIcon } from "@heroicons/react/outline";
import { Button, useCopyToClipboard } from "ui";

type SuccessPaymentLinkAlertProps = {
  formMode: "add" | "edit";
  url: string;
};

export default function SuccessPaymentLinkAlert({
  formMode,
  url,
}: SuccessPaymentLinkAlertProps) {
  return (
    <div className="flex items-start">
      <p className="text-sm">
        Payment link has been {formMode === "add" ? "created" : "updated"}{" "}
        successfully!
      </p>
      <div className="mt-2 flex space-x-2">
        <Copy url={url} />
      </div>
    </div>
  );
}

const Copy = ({ url }: { url: string }) => {
  const [isCopied, setIsCopied] = useState(false);
  const { copy } = useCopyToClipboard();

  return (
    <Button
      variant="secondary"
      size="xs"
      disabled={isCopied}
      onClick={() => {
        if (isCopied) return;

        copy(url).then(() => {
          setIsCopied(true);
          setTimeout(() => {
            setIsCopied(false);
          }, 1000);
        });
      }}
    >
      <span>{isCopied ? "Copied" : "Copy"}</span>
      {isCopied ? (
        <CheckIcon className="h-4 w-4 text-current" />
      ) : (
        <DuplicateIcon className="h-4 w-4 text-current" />
      )}
    </Button>
  );
};
